import React from 'react';
import DataTable from 'react-data-table-component';
import { Calendar, MapPin, Copy, CheckCircle, User } from 'lucide-react';
import { tableStyles } from '../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../i18n';
import Tooltip from '../../../../common/Tooltip';
import { formatDate } from '../../../../../utils/common';

export class SiteVisitListTable extends React.Component {
  constructor() {
    super();
    this.state = {
      copiedId: null,
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleRowsPerPageChange = this.handleRowsPerPageChange.bind(this);
  }

  handlePageChange = (page) => {
    if (this.props.onChangePage) {
      this.props.onChangePage(page);
    }
  };

  handleRowsPerPageChange = (newLimit, page) => {
    if (this.props.onChangeRowsPerPage) {
      this.props.onChangeRowsPerPage(newLimit);
    }
  };

  copyFormUrl = async (formUrl, projectId) => {
    try {
      const fullUrl = `${process.env.REACT_APP_BASE_URL}site-visit?form_url=${formUrl}`;
      await navigator.clipboard.writeText(fullUrl);

      this.setState({ copiedId: projectId });

      // Reset the copied state after 2 seconds
      setTimeout(() => {
        this.setState({ copiedId: null });
      }, 2000);
    } catch (err) {
      console.error('Failed to copy form URL: ', err);

      const textArea = document.createElement('textarea');
      textArea.value = `${process.env.REACT_APP_BASE_URL}site-visit?form_url=${formUrl}`;
      document.body.appendChild(textArea);
      textArea.select();
      document.body.removeChild(textArea);

      this.setState({ copiedId: projectId });
      setTimeout(() => {
        this.setState({ copiedId: null });
      }, 2000);
    }
  };

  getColumns() {
    const { currentPage = 1, limit = 15 } = this.props;

    const { copiedId } = this.state;
    const baseColumns = [
      {
        name: '#',
        width: '70px',
        sortable: false,
        cell: (_, index) => (currentPage - 1) * limit + (index + 1),
      },
      // {
      //   name: 'ID',
      //   selector: (row) => row.id,
      //   sortable: true,
      //   width: '80px',
      // },
      {
        name: i18n.t('Project Name'),
        sortable: true,
        width: '200px',
        cell: (row) => (
          <div style={{ fontSize: '13px', fontWeight: '500' }}>{row.project_name || '-'}</div>
        ),
      },
      {
        name: i18n.t('Form URL'),
        sortable: true,
        width: '250px',
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-between">
            <div
              style={{
                fontSize: '13px',
                fontWeight: '500',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '180px',
              }}
            >
              {row.form_url
                ? `${process.env.REACT_APP_BASE_URL}site-visit?form_url=${row.form_url}`.substring(
                    0,
                    30
                  ) + '...'
                : '-'}
            </div>
            {row.form_url && (
              <Tooltip
                icon={copiedId === row.id ? CheckCircle : Copy}
                tooltipText={copiedId === row.id ? i18n.t('copied') : i18n.t('copy_form_url')}
                onClick={() => this.copyFormUrl(row.form_url, row.id)}
                size={16}
                className={copiedId === row.id ? 'text-success' : 'text-primary'}
              />
            )}
          </div>
        ),
      },
      {
        name: i18n.t('Start Date'),
        sortable: true,
        width: '160px',
        cell: (row) => (
          <div className="d-flex align-items-center">
            <Calendar size={14} className="me-1" />
            {formatDate(row.start_at)}
          </div>
        ),
      },
      {
        name: i18n.t('End Date'),
        sortable: true,
        width: '160px',
        cell: (row) => (
          <div className="d-flex align-items-center">
            <Calendar size={14} className="me-1" />
            {formatDate(row.end_at)}
          </div>
        ),
      },
      {
        name: i18n.t('Places Count'),
        sortable: true,
        width: '120px',
        center: true,
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-center">
            <MapPin size={14} className="me-1" />
            {row.places_count || (row.places ? row.places.length : 0)}
          </div>
        ),
      },
      {
        name: i18n.t('Forms Count'),
        sortable: true,
        width: '120px',
        center: true,
        cell: (row) => (
          <div className="d-flex align-items-center justify-content-center">
            <User size={14} className="me-1" />
            {row.forms_count || (row.forms ? row.forms.length : 0)}
          </div>
        ),
      },
      // {
      //   name: i18n.t('Status'),
      //   sortable: true,
      //   width: '120px',
      //   center: true,
      //   cell: (row) => <StatusBadge status={row.status} />,
      // },

      // {
      //   name: i18n.t('Actions'),
      //   width: '180px',
      //   center: true,
      //   cell: (row) => (
      //     <div className="d-flex align-items-center justify-content-center gap-2">
      //       <Tooltip
      //         icon={Eye}
      //         tooltipText={i18n.t('view_project')}
      //         onClick={() => this.handleView(row)}
      //         size={16}
      //         className="text-primary"
      //       />
      //       <Tooltip
      //         icon={Edit}
      //         tooltipText={i18n.t('edit_project')}
      //         onClick={() => this.handleEdit(row)}
      //         size={16}
      //         className="text-warning"
      //       />
      //       <Tooltip
      //         icon={Trash2}
      //         tooltipText={i18n.t('delete_project')}
      //         onClick={() => this.handleDelete(row)}
      //         size={16}
      //         className="text-danger"
      //       />
      //     </div>
      //   ),
      // },
    ];

    return baseColumns;
  }

  render() {
    const { siteVisits = [], currentPage = 1, limit = 15, total = 0 } = this.props;

    return (
      <>
        <DataTable
          key={`${currentPage}-${limit}`}
          title=""
          columns={this.getColumns()}
          data={siteVisits}
          customStyles={tableStyles}
          highlightOnHover
          pagination
          paginationServer
          paginationTotalRows={total}
          paginationPerPage={limit}
          paginationDefaultPage={currentPage}
          paginationRowsPerPageOptions={[15, 25, 50, 100]}
          paginationComponentOptions={{
            rowsPerPageText: i18n.t('rows_per_page'),
            rangeSeparatorText: i18n.t('out'),
          }}
          onChangeRowsPerPage={this.handleRowsPerPageChange}
          onChangePage={this.handlePageChange}
        />
      </>
    );
  }
}
